import { FILTER_FIELDS } from '@constants';

export const communicationFiltersFields = {
  message_date: {
    ...FILTER_FIELDS.Date,
    label: 'Date',
  },
};
